<template>
	<div class="content" style="background-color: #f1f1f1;">
		<div class="max_view" v-if="windowWidth > 768">

			<!-- <img class="top_img" width="100%" src="../../static/img/index/top_img.png" /> -->
			<div class="row clearfix" style="max-width: 1440px;margin: 0 auto;margin-top: 38px;" v-if="newsList">
				<!-- <img style="width: 8rem;margin-left: 6px;" src="../../static/img/index/ic_news.png" /> -->
				<div class="flex row justify-between" style="width: 100%;padding-left: 20px;">
					<h4>新闻动态</h4>
					<router-link to='/news' class="more_btn2">
						<div style="color:#222;cursor: pointer;font-size: 24px;">
							查看更多 <img width="18" height="20" src="../../static/img/media/next.png" /></div>
					</router-link>
				</div>
				<div class="col-md-12 column" style="margin-top:20px">
					<div class="row clearfix" v-if="newsList && newsList.length > 0">
						<div class="col-md-8 column" style="height: 620px;" @click="gotoDetail(newsList[0].Id)">
							<div class="thumbnail">
								<img height="460" alt="300x200" :src="newsList[0].ImageUrl" />
								<div class="caption" style="height: 154px;">
									<h4>
										{{ newsList[0].Title }}
									</h4>
									<p class="flex align-items-center align-center justify-content-between">
										<span>{{ formatDate(newsList[0].ReleaseDate) }}</span>
										<!-- <img style="width: 8px;height: 13px;" src="../../static/img/index/ic_right.png"/> -->
									</p>
								</div>
							</div>
						</div>
						<div class="col-md-4 column" style="height: 620px;" @click="gotoDetail(newsList[1].Id)">
							<div class="thumbnail">
								<img height="320" alt="300x200" :src="newsList[1].ImageUrl" />
								<div class="caption" style="height: 294px;">
									<h4>
										{{ newsList[1].Title }}
									</h4>
									<p
										class="flex align-items-center justify-content-between border-top padding-top-xs margin-top-xxl">
										<span>{{ formatDate(newsList[1].ReleaseDate) }}</span>
										<img style="width: 8px;height: 13px;" src="../../static/img/index/ic_right.png" />
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4" v-for="(item, index) in newsList" :key="index" v-if="index > 1"
							@click="gotoDetail(item.Id)">
							<div class="thumbnail">
								<img height="320" alt="300x200" :src="item.ImageUrl" />
								<div class="caption">
									<h4>{{ item.Title }}</h4>
									<p
										class="flex align-items-center justify-content-between border-top padding-top-xs margin-top-xxl">
										<span>{{ formatDate(item.ReleaseDate) }}</span>
										<img style="width: 8px;height: 13px;" src="../../static/img/index/ic_right.png" />
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<img style="width: 100%;margin-top: 112px;" src="../../static/img/index/ic_text.png" />
		</div>
		<div class="min_view" v-else>
			<b-navbar toggleable="lg" type="dark" fixed="top" class="topBg">
				<b-navbar-brand href="/">
					<img :width="windowWidth > 768 ? 145 : 100" src="../../static/img/index/ic_newlogo.png" />
				</b-navbar-brand>
				<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
				<b-collapse id="nav-collapse" is-nav target="nav-collapse" v-show="isShow">
					<b-navbar-nav class="ml-auto" small>
						<b-nav-item v-for="(item, index) in menuList" :key="index" @click="gotoPage(index, item)"><span
								:class="{ active: index == k }">{{ $t('head.' + item.label) }}</span></b-nav-item>
					</b-navbar-nav>
					<span class="lanBox">
						<el-button :class="lan == 'zh' ? 'text-bold' : 'text-white'" type="text"
							@click="changeLan('zh')">简体</el-button> |
						<el-button :class="lan == 'en' ? 'text-bold' : 'text-white'" type="text"
							@click="changeLan('en')">EN</el-button>
					</span>
				</b-collapse>
			</b-navbar>


			<div class="homepage-video">
				<!-- <video id="vi" class="video-player" autoplay="autoplay" loop="loop" muted :src="videoSrc">
          </video> -->
				<!-- <video id="vi" class="video-player" autoplay="autoplay" loop="loop" webkit-playsinline playsinline
					x5-playsinline muted>
					<source :src="videoSrc1" type="video/mp4" autoplay="autoplay" loop="loop" muted webkit-playsinline
						playsinline x5-playsinline>
				</video> -->
				<img style="width: 100vw;height: 100vh;" src="../../static/img/index/index1.gif" />
			</div>
			<div class="first_title">
				<div class="first_left">
					<img width="72" src="../../static/img/index/ic_yny.png" />
					<div style="font-size:25px;font-weight: bold;margin-top: 8px;">房车旅游</div>
					<div style="font-size:16px;margin-top: 15px;">
						打造一站式房车旅游综合服务平台
						<br />
						助力房车文旅产业高质量发展
					</div>
				</div>
			</div>
			<div class="news_view margin-lr-sm">
				<div class="flex row justify-between border-top padding-top"
					style="position: relative; margin: -112px 0 0;">
					<h4 style="color: #fff !important;">新闻动态</h4>
					<router-link to='/news' class="more_btn2">
						<div style="cursor: pointer;font-size: 16px;">
							查看更多 <img width="12" src="../../static/img/media/next.png" /></div>
					</router-link>
				</div>
				<div class="item_view margin-top-sm" v-for="(item, index) in newsList" :key="index" v-if="index < 2"
					@click="gotoDetail(item.Id)">
					<div class="thumbnail">
						<img height="320" alt="300x200" :src="item.ImageUrl" />
						<div class="caption padding-top bg-white padding-lr-xs">
							<h4 class="text-left" style="font-size: 18px !important;">{{ item.Title }}</h4>
							<p class="flex align-items-center justify-content-between border-top padding-top-xs margin-top">
								<span>{{ formatDate(item.ReleaseDate) }}</span>
								<img style="width: 8px;height: 13px;" src="../../static/img/index/ic_right.png" />
							</p>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
// import Vue from 'vue';
import api from "../api/api.js";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import { Swipe, SwipeItem } from 'vant';
import Swiper2, { Navigation, Pagination, EffectFade, Autoplay } from "swiper";
Swiper2.use([Navigation, Pagination, EffectFade, Autoplay]);
const c_swiper = document.getElementsByClassName("myswiper1");
const bgSwiper = document.getElementsByClassName("bgSwiper");
// Vue.use(Swipe);
// Vue.use(SwipeItem);
import cxHead from '@/components/cx-head.vue';
export default {
	//import引入的组件需要注入到对象中才能使用
	components: {
		cxHead,
	},
	name: "Index",
	metaInfo() {
		return {
			title: this.pageName, // set a title
			meta: [
				{
					// set meta
					name: "keyWords",
					content: this.SeoKeyword
				},
				{
					name: "description",
					content: this.SeoDescription
				}
			]
		};
	},

	data() {
		return {
			k: 0,
			menuList: [
				{
					label: 'home',
					path: '/',
				},
				{
					label: 'about',
					path: '/about',
				},
				{
					label: 'news',
					path: '/news',
				},
				{
					label: 'service',
					path: '/service',
				},
				{
					label: 'yueniyou',
					path: '/function',
				},
				{
					label: 'theme',
					path: '/media',
				},
				{
					label: 'view',
					path: '/view',
				},

			],
			lan: 'zh',
			windowWidth: window.innerWidth,
			year: "",
			videoSrc: require('../../static/img/index/123.mp4'),
			videoSrc1: require('../../static/img/index/1.mp4'),
			pageName: "",
			SeoKeyword: "",
			SeoDescription: "",
			isShow: false,
			current: 1,
			bgCurrent: 1,
			swiperOption1: {
				// autoplay: {
				// 	disableOnInteraction: false,
				// 	delay: 500,
				// },
				slidesPerView: 1.2,
				// spaceBetween: 20,
				// slidesPerView: 1,
				loop: false,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev"
					// hideOnClick: true,
					// hiddenClass: 'my-button-hidden',
				},
				on: {
					//监听滑动切换事件，返回swiper对象
					slideChange: () => {
						// let swiper = this.$refs.mySwiper.swiper;
						// console.log('轮播图滚动事件  --->', c_swiper[0].swiper.activeIndex);
						this.current = c_swiper[0].swiper.activeIndex + 1;
					}
				}
			},
			swiperOption3: {
				// autoplay: {
				// 	disableOnInteraction: false,
				// 	delay: 500,
				// },
				slidesPerView: 1.3,
				// spaceBetween: 20,
				// slidesPerView: 1,
				loop: true,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev"
				},
				on: {
					//监听滑动切换事件，返回swiper对象
					slideChange: () => {
						console.log("轮播图滚动事件  --->");
					}
				}
			},
			swiperOption2: {
				// effect: 'coverflow',
				// slidesPerView: 2,
				speed: 300,
				// spaceBetween: 20,
				// autoplay: {
				// 	disableOnInteraction: false,
				// 	delay: 3000,
				// },
				// slidesPerView: 2,
				// loop: true,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev"
				},
				on: {
					//监听滑动切换事件，返回swiper对象
					slideChange: () => {
						// let swiper = this.$refs.mySwiper.swiper;
						// console.log(this.realIndex);
						// this.current = this.realIndex + 1;
					}
				}
			},
			swiperOption4: {
				// effect: 'fade',
				// slidesPerView: 2,
				speed: 1000,
				// spaceBetween: 20,
				autoplay: {
					disableOnInteraction: false,
					delay: 5000
				},
				// slidesPerView: 2,
				loop: true,
				// navigation: {
				// 	nextEl: '.swiper-button-next',
				// 	prevEl: '.swiper-button-prev',
				// },
				on: {
					//监听滑动切换事件，返回swiper对象
					slideChange: () => {
						// let swiper = this.$refs.mySwiper.swiper;
						// console.log(this.realIndex);
						// this.current = this.realIndex + 1;
					}
				}
			},
			swiperOption: {
				// autoplay: {
				// 	disableOnInteraction: false,
				// 	delay: 1000,
				// },
				notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
				direction: "vertical", //垂直方向移动
				grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
				setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
				autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
				slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
				mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
				mousewheelControl: true, //同上
				height: window.innerHeight, // 高度设置，占满设备高度
				resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
				observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

				// 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
				//debugger: true,

				// swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
				on: {
					//监听滑动切换事件，返回swiper对象
					slideChange: () => {
						console.log(
							"轮播图滚动事件11  --->",
							bgSwiper[0].swiper.activeIndex
						);
						this.bgCurrent = bgSwiper[0].swiper.activeIndex + 1;
					},
					click() { }
				}
			},
			newsList: []
		};
	},
	computed: {
		swiper() {
			return this.$refs.bgSwiper.swiper;
		}
	},
	mounted() {
		// this.swiper.slideTo(3, 1000, false); //手动跳到指定页
	},
	components: {
		Swiper,
		SwiperSlide
	},
	created() {
		// this.list = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
		// let video = document.querySelectorAll('video')[0];
		// video.play();
		// document.addEventListener(
		// 	'WeixinJSBridgeReady',
		// 	function() {
		// 		video.play();
		// 	},
		// 	false
		// );
		let date = new Date();
		this.year = date.getFullYear();
		this.getSiteData();
		this.getNewsPageData();
	},
	methods: {
		changeLan(lan) {//语言切换
			this.lan = lan;
			this.$i18n.locale = lan
		},
		gotoPage(index, item) {
			this.k = index;
			sessionStorage.removeItem("tabCur");
			this.$router.push(item.path);
			if (this.windowWidth <= 768) {
				this.isShow = false
			}
		},
		formatDate(date) { //格式化日期
			if (date) {
				let date1 = new Date(date.replace(/-/g, '/'));
				date = this.common.formatDate(new Date(date1), 'yyyy年MM月dd日');
			}
			return date;
		},
		nextPage() {
			bgSwiper[0].swiper.slideNext();
		},
		gotoTopPage(index, item) {
			this.k = index;
			this.$router.push(item.path);
		},
		getNewsPageData() {
			let that = this;
			let data = {
				page: 1,
				rows: 5,
				sort: "IsTop,ReleaseDate",
				// wheres: "[{ name: 'IsTop', value:'1' }]"
			};
			this.$axios
				.post(api.GetNewsPageData, data)
				.then(function (response) {
					that.newsList = response.data.rows;
					// console.log("更多数据", that.newList);
					// self.goodsList = self.goodsList.concat(res.Data);
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		gotoDetail(id) {
			//跳转新闻详情
			this.$router.push({
				path: "/newsText",
				query: { id: id }
			});
		},


		onChange(index) {
			this.current = index + 1;
		},
		getSiteData() {
			//获取seo关键字
			let that = this;
			that.$axios
				.post(api.GetSiteData, {})
				.then(function (response) {
					console.log("seo优化", response);
					let data = response.data;
					that.pageName = data.Title
						? data.Title
						: "约你游·一站式房车旅游综合服务平台";
					that.SeoKeyword = data.SeoKeyword
						? data.SeoKeyword
						: "约你游·一站式房车旅游综合服务平台";
					that.SeoDescription = data.SeoDescription
						? data.SeoDescription
						: "约你游·一站式房车旅游综合服务平台";
				})
				.catch(function (error) {
					console.log(error);
				});
		},

		showDownload() {
			this.isShow = true;
		},
		hideDownload() {
			this.isShow = false;
		},
		handleScroll() {
			var scrollTop =
				window.pageYOffset ||
				document.documentElement.scrollTop ||
				document.body.scrollTop;
			// console.log(scrollTop);
		},
		goto(e, i) {
			this.$router.push({
				path: e,
				query: { index: i }
			});
			// this.$router.push(i);
		}
	},
	mounted() {
		window.addEventListener("scroll", this.handleScroll);
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
video::-webkit-media-controls-fullscreen-button {
	display: none;
}

video::-webkit-media-controls-play-button {
	display: none;
}

video::-webkit-media-controls-timeline {
	display: none;
}

video::-webkit-media-controls-current-time-display {
	display: none;
}

video::-webkit-media-controls-time-remaining-display {
	display: none;
}

video::-webkit-media-controls-mute-button {
	display: none;
}

video::-webkit-media-controls-toggle-closed-captions-button {
	display: none;
}

video::-webkit-media-controls-volume-slider {
	display: none;
}

video::-webkit-media-controls-enclosure {
	display: none;
}

.content {
	// padding-bottom: 90px;
	width: 100%;
	background-color: #f1f1f1;
}


.homepage-video {
	width: 100%;
	height: 100%;
	overflow: hidden;
	/* position: absolute; */
	left: 0;
	top: 0;
}

.video-player {
	object-fit: cover;
	width: 100%;
	height: 100%;
}

@media (min-width: 768px) {

	.col-md-8,
	.col-md-4 {
		padding-right: 6px !important;
		padding-left: 6px !important;
		// background-color: #fff;
		border-radius: 10px 10px 0 0;
		margin-top: 10px;

		img {
			border-radius: 10px 10px 0 0;
		}

		.caption {
			background-color: #fff;
			padding: 50px 40px;
			text-align: left;

			h4 {
				font-size: 24px;
				height: 60px;
			}
		}
	}

	.max_view {
		display: block !important;

		.homePageTop {
			position: relative;
			text-align: center;

			.top_text0 {
				position: absolute;
				top: 50%;
				left: 50%;
				margin-top: -64px;
				margin-left: -68px;
			}

			.top_text {
				position: absolute;
				top: 50%;
				left: 50%;
				margin-top: 30px;
				margin-left: -434px;
			}
		}
	}

	.min_view {
		display: none;
	}
}

@media (max-width: 768px) {

	.min_view {
		/* max-width: 375px; */
		display: block;
		overflow-x: hidden;
	}

	.swiper-slide {
		/* font-size: 24px;
		text-align: center;
		line-height: 100px; */
		position: relative;
	}

	.swiper-slide:nth-child(2n) {
		background: #fff;
	}

	.swiper-slide:nth-child(2n-1) {
		background: #f8f8f8;
	}

	.first_title {

		color: #fff;
		position: absolute;
		top: 24%;
		text-align: left;
	}

	.first_left {
		margin-left: 32px;
	}
}

.thumbnail {
	display: flex;
	flex-direction: column;
	cursor: pointer;

	// .caption{
	// 	flex: 1;
	// }
	h4 {
		font-size: 24px !important;
		font-style: normal;
	}
}

.thumbnail img {
	width: 100%;
}

.more_btn2 {
	color: #0C8C69;
	font-size: 20px;
	cursor: pointer;
}

.navbar-dark .navbar-nav .nav-link {
	font-size: 16px !important;
}

h1,
h2 {
	font-weight: normal;
}

ul {
	list-style-type: none;
	padding: 0;
}

.active {
	color: #fff !important;
	font-weight: bold;
}

li {
	display: inline-block;
	margin: 0 10px;
}

a {
	color: #42b983;
}

.navbar-dark .navbar-nav .nav-link {
	font-size: 14px;
}

@media (max-width: 768px) {
	.fixed-top {
		// background: #fff;
		background-color: rgba(0, 0, 0, 0.5);
	}

	.navbar {
		// padding: 0rem 1rem;
	}

	// }

	// @media (max-width: 576px) {
	.navbar {
		padding: 5px 10px !important;
	}

	.navbar-collapse {
		// background-color: rgba(0, 0, 0, 0.85);
		height: 100vh;
	}

	.navbar-toggler {
		font-size: 0.8rem;
		outline: none;
	}
}

@media (min-width: 768px) {
	.fixed-top {
		padding: 5px 240px;
	}

	.topBg {
		background-color: rgba(0, 0, 0, 0.3);
	}

	.isFixed {
		background: #42b983;
	}

	.lanBox {
		margin-left: 30px;
		font-size: 16px;
		color: #fff;

		button {
			outline: none;
			margin-left: 0;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue